/** Sale price applies only while it is lower than the normal price and has not ended. */
export function effectivePriceCents(
  p: { price_cents: number; sale_price_cents: number | null; sale_ends_at: string | null },
  now: Date = new Date(),
): number {
  const sale = p.sale_price_cents;
  if (sale == null || sale < 100 || sale >= p.price_cents) return p.price_cents;
  if (p.sale_ends_at && new Date(p.sale_ends_at).getTime() <= now.getTime()) return p.price_cents;
  return sale;
}

export const SHOP_NEEDS = [
  { id: "anxiety", label: "Anxiety" },
  { id: "sleep", label: "Sleep" },
  { id: "sensory", label: "Sensory Comfort" },
  { id: "self-discovery", label: "Self-Discovery" },
  { id: "regulation", label: "Emotional Regulation" },
] as const;

export const AFFILIATE_DISCLOSURE =
  "Some links are Amazon affiliate links. As an Amazon Associate we may earn a small commission from qualifying purchases, at no extra cost to you.";

const CATEGORY_LABELS: Record<string, string> = {
  "calming-sensory": "Calming & Sensory Tools",
  "journals-workbooks": "Journals & Workbooks",
  "sleep-relaxation": "Sleep & Relaxation",
  "books-learning": "Books & Learning",
  "gift-memberships": "Gift Memberships",
  "digital-resources": "Digital Recovery Resources",
};
export function categoryLabel(slug: string) {
  return CATEGORY_LABELS[slug] ?? slug.replace(/-/g, " ");
}
